import React from "react";
import { Modal } from "react-bootstrap";

const DeleteAllConfirmation = ({ showModal, closeModal, type, onDelete, startDate, endDate }) => {
  return (
    <>
      <Modal
        show={showModal}
        size="md"
        className="custom-modal blur-bg"
        centered
        onHide={closeModal}
      >
        <Modal.Header>
          <div className="border-0 pb-0 d-flex justify-content-between w-100">
            <h6 className="modal-title text-blue-900">
              Are you sure you want to delete all {type} data from {startDate} to {endDate} ?
            </h6>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}
            ></button>
          </div>
        </Modal.Header>
        <Modal.Body className="py-1 px-4">
          <div className="grid gap-3 mt-6 p-4">
            <button
              className="btn btn-outline-primary g-col-6"
              type="button"
              onClick={closeModal}
            >
              <span className="btn-upper-case">Cancel</span>
            </button>
            <button
              className="btn btn-primary g-col-6"
              type="button"
              onClick={onDelete}
            >
              <span className="btn-upper-case">Yes</span>
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DeleteAllConfirmation;
